import styled from '@emotion/styled';
import type { LayoutPreset } from 'modules/manager/domain/layout-blocks';
import React from 'react';
import { editorAccent } from '../editor-accent';

interface LayoutPresetCardProps {
  preset: LayoutPreset;
  selected?: boolean;
  onClick: () => void;
}

const VIEW_W = 160;
const VIEW_H = 90;

const LayoutPresetCard: React.FC<LayoutPresetCardProps> = ({ preset, selected, onClick }) => (
  <Root type="button" data-selected={selected ? 'true' : 'false'} onClick={onClick}>
    <Thumb viewBox={`0 0 ${VIEW_W} ${VIEW_H}`}>
      <rect x={0} y={0} width={VIEW_W} height={VIEW_H} fill="#f9fafb" />
      {preset.regions.map((r, i) => (
        <rect
          key={i}
          x={r.x * VIEW_W + 1}
          y={r.y * VIEW_H + 1}
          width={Math.max(0, r.w * VIEW_W - 2)}
          height={Math.max(0, r.h * VIEW_H - 2)}
          fill={editorAccent.wash}
          stroke={editorAccent.solid}
          strokeWidth={1}
          strokeDasharray="4 3"
        />
      ))}
    </Thumb>
    <Label>{preset.label}</Label>
  </Root>
);

export default React.memo(LayoutPresetCard);

const Root = styled.button`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #ffffff;
  cursor: pointer;
  text-align: left;

  &:hover {
    border-color: #9ca3af;
  }

  &[data-selected='true'] {
    border-color: ${editorAccent.solid};
    box-shadow: 0 0 0 2px ${editorAccent.ring};
  }
`;

const Thumb = styled.svg`
  width: 100%;
  height: auto;
  aspect-ratio: ${VIEW_W} / ${VIEW_H};
  display: block;
`;

const Label = styled.span`
  font-size: 12px;
  color: #111827;
`;
